<template>
  <Row>
    <Col span="24"
      ><p class="kanbanDes">
        <label>正常考勤</label><span>{{ onDuty }}</span> <label>异常考勤</label
        ><span>{{ notDuty }}</span>
      </p></Col
    >
    <Col
      span="24"
      style="text-align: center; margin-bottom: 20px; margin-top: 20px"
    >
      <i-circle
        :percent="(onLine / total) * 100"
        :size="120"
        :trail-width="10"
        trail-color="#163358"
        :stroke-width="10"
        stroke-color="#23d927"
      >
        <p style="font-size: 28px; margin-bottom: 10px; color: #23d927">
          {{ attdRate }}
        </p>
        <p style="color: #23d927">出勤率/%</p>
      </i-circle> </Col
    ><Col span="24">
      <Row style="text-align: center">
        <Col span="8"
          ><h2 class="dweew">{{ total }}</h2>
          <p>应出勤人数</p></Col
        >
        <Col span="8">
          <h2 class="dweew">{{ onLine }}</h2>
          <p>现出勤人数</p>
        </Col>
        <Col span="8">
          <h2 class="dweew">{{ askLeave }}</h2>
          <p>请假人数</p>
        </Col>
      </Row>
    </Col>
  </Row>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      onLine: 0,
      total: 0,
      item: {},
      attdRate: 0,
      onDuty: 0,
      notDuty: 0,
      askLeave: 0,
    };
  },
  methods: {
    zaixianlv(t) {
      var x;
      var d = (t / this.total) * 100;
      x = d.toFixed(2);
      return x;
    },
    getData() {
      axios({
        method: "post",
        url: axios.upf + "/screen/countAttd/person",
        data: this.item,
      }).then((res) => {
        var data = res.data.data;
        this.onLine = data.actualAttd;
        this.total = data.mustAttd;
        this.attdRate = data.attdRate;
        this.onDuty = data.onDuty;
        this.notDuty = data.notDuty;
        this.askLeave = data.askLeave;
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="">
h2.dweew {
  font-size: 24px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/control/youhao.vue